export const getUniqueName = (originalName, listOfNames, maxNameLength = 1024) => {
  const isNameUnique = name => listOfNames.every(n => n !== name);

  let index = 0;
  let newName;

  do {
    if (index === 0) {
      const prefix = "Copy of ";
      const availableLength = maxNameLength - prefix.length;
      const truncatedOriginal = originalName.substring(0, availableLength);
      newName = prefix + truncatedOriginal;
    } else {
      const prefix = "Copy of ";
      const suffix = " (" + index + ")";
      const availableLength = maxNameLength - prefix.length - suffix.length;
      const truncatedOriginal = originalName.substring(0, availableLength);
      newName = prefix + truncatedOriginal + suffix;
    }
    index++;
  } while (!isNameUnique(newName));

  return newName;
};